import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { RouteUrls } from '../configs/routeUrls';
import Cookies from 'js-cookie';
import { HelpPage } from './HelpPage';

export class TopToolBar extends Component {
	constructor() {
		super();

		this.currentFontSize = parseInt(document.documentElement.style.fontSize) || 15;

		this.handleClickIncrease = this._handleClickIncrease.bind(this);
		this.handleClickDecrease = this._handleClickDecrease.bind(this);
		this.handleClickChangeContrast = this._handleClickChangeContrast.bind(this);
	}

	_handleClickChangeContrast() {
		if (!document.body.classList.contains('contrast')) {
			document.body.classList.add('contrast');
			Cookies.set('contrast', '1');
		} else {
			document.body.classList.remove('contrast');
			Cookies.set('contrast', '0');
		}
	}

	_handleClickIncrease() {
		if (this.currentFontSize < 19) {
			this.currentFontSize++;
			document.documentElement.style.fontSize = this.currentFontSize + 'px';
			Cookies.set('font-size', this.currentFontSize + 'px');
		}
	}

	_handleClickDecrease() {
		if (this.currentFontSize > 15) {
			this.currentFontSize--;
			document.documentElement.style.fontSize = this.currentFontSize + 'px';
			Cookies.set('font-size', this.currentFontSize + 'px');
		}
	}

	render() {
		const { helpPageData } = this.props;
		return (
			<div className="top-tool-bar">
				<div className="top-tool-bar__container container">
					<div className="top-tool-bar__wcag">
						<div
							id="increase-font"
							className="top-tool-bar__increase-font"
							onClick={this.handleClickIncrease}
							role="button"
							title="Zwiększ rozmiar czcionki"
						>
							<span aria-hidden="true">A+</span>
						</div>
						<div
							id="decrease-font"
							onClick={this.handleClickDecrease}
							className="top-tool-bar__decrease-font"
							role="button"
							title="Zmniejsz rozmiar czcionki"
						>
							<span aria-hidden="true">A-</span>
						</div>
						<div
							id="change-contrast"
							onClick={this.handleClickChangeContrast}
							className="top-tool-bar__change-contrast"
							role="button"
							title="Przełącz na wersję kontrastową"
						>
							<i className="fa fa-adjust top-tool-bar__icon" aria-hidden="true" />
							<span aria-hidden="true">Wersja kontrastowa</span>
						</div>
					</div>
					{
						// <div className="text text--danger text--weight-700 text--font-size-25 text--right-40">Strona testowa</div>
					}
					<HelpPage {...helpPageData} />
				</div>
			</div>
		);
	}
}
